import {deleteMethod, getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownProductContractImages', request)
}

async function post(request) {
    return await postMethod('/api/ownProductContractImages', request, {'Content-Type': 'multipart/form-data'})
}

async function put(id, request) {
    return await putMethod(`/api/ownProductContractImages?contractId=${id}`, request, {
        'Content-Type': 'multipart/form-data',
    })
}

async function remove(request) {
    return await deleteMethod('/proxy/ownProductContractImages', request)
}

export {get, post, put, remove}
